// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { LogLevel, OpenIdConfiguration } from 'angular-auth-oidc-client';
export const environment = {
    production: false,
    stage: 'dev',
    apiUrl: `https://api.dev.cod.siemens-healthineers.com/v1`,
    authentication: {
        unauthorizedRoute: '/auth/unauthorized',
        redirectUrl: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
        clientId: 'a1e1029a-7a3f-48bf-824f-79f3762f310e',
        authority: 'https://login.microsoftonline.com/5dbf1add-202a-4b8d-815b-bf0fb024e033/v2.0',
        authWellknownEndpointUrl:
            'https://login.microsoftonline.com/5dbf1add-202a-4b8d-815b-bf0fb024e033/v2.0/.well-known/openid-configuration',
        scope: 'openid profile email offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        disableIatOffsetValidation: true,
        autoUserInfo: true,
        renewTimeBeforeTokenExpiresInSeconds: 300,
        renewUserInfoAfterTokenRenew: true,
        ignoreNonceAfterRefresh: true,
        logLevel: LogLevel.Debug,
        maxIdTokenIatOffsetAllowedInSeconds: 301,
        clockSkewInSec: 301
    } as OpenIdConfiguration
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
